import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom';

function Services({ serviceId, servicename }) {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                const transformedData = result.data.map((item) => ({
                    id: item.id,
                    name: item.category,
                    image: `${item.categoryIcon}`,
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#FFFFFF" }}>
                <div className="container-xxl py-5 my-1">
                    <div className="container py-5"></div>

                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 500 }}
                    >
                        <p className="display-6 text-black text-uppercase mb-2">Our Services</p>
                    </div>

                    {loading && <p className="text-center">Loading services...</p>}
                    {error && <p className="text-center text-danger">{error}</p>}

                    {/* ---------------- GRID LAYOUT ---------------- */}
                    {!loading && !error && (
                        <div className="container">
                            <div className="row g-4">
                                {services.map((service) => (
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={service.id}>
                                        <Link
                                            to={`/service/${service.id}/${service.name}`}
                                            className="text-decoration-none"
                                        >
                                            <div className="service-item d-flex flex-column p-3 pb-0"
                                                style={{ backgroundColor: "#f8f9fa", height: "100%" }}
                                            >
                                                <div
                                                    className="position-relative"
                                                    style={{
                                                        height: '350px',
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    <img
                                                        className="img-fluid"
                                                        src={service.image}
                                                        alt={service.name}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </div>

                                                <div className="text-center p-4">
                                                    <h4>{service.name}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Services;
